import {
  ColumnDetail,
  ComplexSelectionFormValue,
  RowDetail,
} from '../../../../../../../../ui/gzSelectableTableRowGroup/types';
import { DeviceType } from '../../../../../utils/uiSettings/deviceControl/device-control.types';
import { getDeviceTypeLabels } from '../../../../../utils/uiSettings/deviceControl/device-control.values';
import { DeviceControlDeviceClassType } from '@nirvana/shared/dtos/types/policies/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';

export enum Columns {
  ALLOWED = 1,
  BLOCKED = 2,
}

export function columns(): ColumnDetail<Columns>[] {
  return [
    {
      column: Columns.ALLOWED,
      label: translateFn('Allowed'),
    },
    {
      column: Columns.BLOCKED,
      label: translateFn('Blocked'),
    },
  ];
}

export function getRows(
  permissions: ComplexSelectionFormValue<DeviceType, Columns>,
  deviceClass: DeviceControlDeviceClassType
): RowDetail<DeviceType, Columns>[] {
  return Object.keys(permissions)
    .filter(key => permissions[key].enabled === true)
    .map(key => {
      return {
        key: key as DeviceType,
        label: getDeviceTypeLabels(key as DeviceType, deviceClass),
      };
    });
}
